
<p-sidebar *ngIf="checkSideBarVisiblity()" transitionOptions="150ms cubic-bezier(0.1, 0.7, 1.0, 0.1)" [styleClass]="navigation_open ? '': 'sideBarCollapse'"
[visible]="true" [modal]="false">
<ng-template pTemplate="header">
  <div class="nav-header">
    <img class="sidebar-open-button" *ngIf="navigation_open" (click)="navigation_open = !navigation_open;this.selected_menu_item.expanded =false;tooltipShow()" src="./../assets/images/navBarIcons/menu-outline.svg">
    <img  class="sidebar-open-button" *ngIf="!navigation_open" (click)="navigation_open = !navigation_open;tooltipShow()" src="./../assets/images/navBarIcons/menu-outline.svg">
  </div>
</ng-template>
<div class="main-body">
  <div class="nav-menu">
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <p-panelMenu [multiple]="false" [styleClass]="navigation_open ? '': 'sideBarCollapse'"  [model]="menu_data"> 
    </p-panelMenu>
  </p-scrollPanel >
</div>
</div>
</p-sidebar>
<div  *ngIf="checkSideBarVisiblity()" (click)="navigationService.navigationCheck()" class="main-header">
     <img class="logo" src="./../../../assets/images/logo/logo.png" (click)="homePage()">
     <img class="logo-text" src="./../../assets/images/dashboard/Smart Pricing.png">
     <div class="header-actions">
        <div class="dropdown header-icons">
          <img class="notification_img" *ngIf="notification_available" src="./../../../assets/images/navBarIcons/notification.svg" (click)="notificationOpen()">
          <img class="notification_img"  *ngIf="!notification_available" (click)="notificationOpen()" src="./../../../assets/images/navBarIcons/notification_inactive.svg">
          <img class="dropdown-toggle" role="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  src="./../../../assets/images/navBarIcons/circle-user-regular.svg">
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
            <button class="dropdown-item disabled profile-name" type="button">{{user_name}}</button>
            <button class="dropdown-item disabled profile-position" type="button">{{role_name}}</button>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item logout" type="button" (click)="logout()">
              <img src="./../../assets/images/dashboard/Icon ionic-ios-log-out.svg">
              Logout
          </button>
          </div>
        </div>
     </div>
</div>